import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgGear = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M17.5 5.833 10 1.666 2.5 5.833v8.333l7.5 4.167 7.5-4.167zM10 12.777c1.594 0 2.887-1.243 2.887-2.778S11.594 7.222 10 7.222 7.113 8.465 7.113 9.999 8.406 12.777 10 12.777Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgGear);
export default ForwardRef;
